module.exports = __webpack_public_path__ + "frontend/static/media/profile.efe4e181.png";